import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { DropdownOption } from './DropdownOption';

// Styles
import style from './styles.pcss';

const cx = classNames.bind(style);

const DropdownList = ({
  options, activeOption, onOptionClicked, isDayToggle, className,
}) => (
  <ul className={cx('list', { 'list--arrow-toggle': !isDayToggle }, className)}>
    {options.map((option) => (
      <li key={option.slug} className={cx('option')}>
        <DropdownOption
          {...option}
          active={option.slug === activeOption.slug}
          onClick={() => onOptionClicked(option)}
        />
      </li>
    ))}
  </ul>
);

DropdownList.propTypes = {
  options: PropTypes.array,
  activeOption: PropTypes.object,
  onOptionClicked: PropTypes.func,
  isDayToggle: PropTypes.bool,
  className: PropTypes.string,
};

export { DropdownList };
